import { render } from "./B2bFilterButtonInventoryReport.vue?vue&type=template&id=3afd5217&scoped=true"
import script from "./B2bFilterButtonInventoryReport.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonInventoryReport.vue?vue&type=script&lang=js"

import "./B2bFilterButtonInventoryReport.vue?vue&type=style&index=0&id=3afd5217&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afd5217"]])

export default __exports__